import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import NewSmartAllocationCustomization from './NewSmartAllocationCustomization';

const SmartAllocationCustomizationPicker = ({ tabResource }) => {
  return pick(tabResource, {
    [fr.relationships.newTabData.name]: <NewSmartAllocationCustomization sacRelationship={tabResource?.relationship(fr.relationships.newTabData.name)} />,
    [fr.relationships.tabData.name]: <NewSmartAllocationCustomization sacRelationship={tabResource?.relationship(fr.relationships.tabData.name)} />,
  }, null);
};

SmartAllocationCustomizationPicker.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default SmartAllocationCustomizationPicker;
